import { render, staticRenderFns } from "./TrailWelcome.vue?vue&type=template&id=1735bdb3"
import script from "./TrailWelcome.vue?vue&type=script&lang=js"
export * from "./TrailWelcome.vue?vue&type=script&lang=js"
import style0 from "./TrailWelcome.vue?vue&type=style&index=0&id=1735bdb3&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports